import { render } from "./tab-booking-success.vue?vue&type=template&id=0ca0af8c&ts=true"
import script from "./tab-booking-success.vue?vue&type=script&lang=ts"
export * from "./tab-booking-success.vue?vue&type=script&lang=ts"

import "./tab-booking-success.vue?vue&type=style&index=0&id=0ca0af8c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__